import { Formattable } from 'visuris/Data/Entities/Formattable';
import { PushSubscriptionType } from '../../Helpers/Enums';

export default class PushMessageSubscription extends Formattable {

    public id: number = null;
    public pushSubscriptionType: PushSubscriptionType = null;
    public userId: string = null;
    public createdAt: Date = null;
    public modifiedAt: Date = null;
    public lastSentAt?: Date = null;
    public lastStatus?: number = null;
    public lastError?: string = null;
    public application: number = null;
    public deviceType: number = null;
    public enabled: boolean = null;
    // VapidPushMessageSubscription properties
    public endpoint?: string = null;
    public auth?: string = null;
    public p256dh?: string = null;

    constructor() {
        super();
    }

    protected getFormatters(): any {
        return {};
    }
}